namespace Gamification.Gamification {
    export interface UtentiProdottiBadgeForm {
        IdUtente: Serenity.IntegerEditor;
        IdUtenteProdotto: Serenity.IntegerEditor;
        IdProdottoBadge: Serenity.LookupEditor;
        DataOra: Serenity.DateTimeEditor;
        Stato: Serenity.IntegerEditor;
    }

    export class UtentiProdottiBadgeForm extends Serenity.PrefixedContext {
        static formKey = 'Gamification.UtentiProdottiBadge';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!UtentiProdottiBadgeForm.init)  {
                UtentiProdottiBadgeForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.LookupEditor;
                var w2 = s.DateTimeEditor;

                Q.initFormType(UtentiProdottiBadgeForm, [
                    'IdUtente', w0,
                    'IdUtenteProdotto', w0,
                    'IdProdottoBadge', w1,
                    'DataOra', w2,
                    'Stato', w0
                ]);
            }
        }
    }
}
